import { Component, Input } from '@angular/core';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-r1301-overview-devices',
	templateUrl: './r1301-overview-devices.component.html',
	styleUrls: ['./r1301-overview-devices.component.css']
})
export class R1301OverviewDevicesComponent {
	@Input() key: string;
	@Input() sectionclass: string;
	@Input() sectiontitle: string;
	@Input() nodatamessage: any;

	public reloadSubscription: Subscription;
	public widgetDataSubscription: Subscription;
	public hasData = true;
	public showLoad = true;
	public desktopClicks;
	public mobileClicks;

	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngAfterViewInit(): void {
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success && response.data.length > 0) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData: any): void {
		responseData.forEach((data) => {
			if (data.device == 'Desktop') {
				this.desktopClicks = parseInt(data.clicks);
			} else if (data.device == 'Mobile') {
				this.mobileClicks = parseInt(data.clicks);
			}
		});
	}
}
